var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.75 22V21.25H20C10.7898 21.25 5.49132 24.721 2.94956 27.8723C3.59128 23.0573 5.72119 19.7308 8.46979 17.5221C11.8049 14.8421 16.1252 13.75 20 13.75H20.75V13V5.99609L31.2534 18L20.75 30.0039V22ZM31.3975 18.1646C31.3973 18.1645 31.3972 18.1643 31.3971 18.1642L31.3975 18.1646ZM31.3971 17.8358C31.3972 17.8357 31.3973 17.8355 31.3975 17.8354L31.3971 17.8358Z","stroke":"currentColor","strokeWidth":"1.5"}));
}

Share.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Share;

Share.default = Share;
